module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeCAYAAABXNvynAAAABGdBTUEAALGPC/xhBQAAAHdJREFUWAntlbENgDAMBBMapqJkCeosymRGIArLtb946VI5zet1PsnzvFYMo7cZdf2qUli9MQhDuBBAiQKk/WtHeMYxuHTtHqRAOyUonLYnGSEswZpCIZxgSEY7wjPunUsnceEPtVOCwkod3mwIQ7gQQIkCpP37AAvyBz12zEeWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag-icons/icons8-germany.png
// module id = 1410
// module chunks = 33